import { IStateSliceDefaults, StateSliceName } from '../store.models';

import { IVenueStateModel } from './venue.models';

export const venueStateDefaults: IStateSliceDefaults<IVenueStateModel> = Object.freeze({
    sliceName: StateSliceName.VENUE,
    defaults: {
        venue: undefined,
        surfaceConfig: undefined,
    }
});
